import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "xing",
  "use": "xing-usage",
  "viewBox": "0 0 435 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 435 512\" id=\"xing\"><path d=\"M39.6 101.1c-4.4 0-8.2 1.6-10.1 4.6-1.9 3.2-1.6 7.2.4 11.3l49.8 86.4c.1.2.1.3 0 .4L1.5 342.4c-2 4.1-1.9 8.2 0 11.3 1.9 3 5.2 5 9.6 5h73.7c11 0 16.3-7.4 20.1-14.3 0 0 76.6-135.7 79.6-141-.3-.5-50.7-88.5-50.7-88.5-3.7-6.5-9.2-13.8-20.5-13.8H39.6zM349.3 0c-11 0-15.8 6.9-19.7 14.1 0 0-158.8 282.1-164 291.4.3.5 104.7 192.5 104.7 192.5 3.7 6.5 9.3 14.1 20.6 14.1h73.6c4.4 0 7.9-1.7 9.8-4.7 2-3.1 1.9-7.3-.2-11.4L270.2 305.7c-.1-.1-.1-.3 0-.5L433.4 16.1c2.1-4.1 2.1-8.2.2-11.4-1.9-3-5.4-4.7-9.8-4.7h-74.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./sv_cms/static/assets/images/icons/xing.svg
// module id = 287
// module chunks = 6